<div class="authentication-layout-container">
  <app-header></app-header>
  <header class="authentication-layout-header">
    <span>International Freight Forwarders</span>
  </header>
  <router-outlet></router-outlet>
</div>
